import React from 'react'
/**
 * Helpers
 */
import {pure} from '@react/store'
import {http} from '@helpers/common'
import {
  HttpResponse,
  PostInterface,
  DefaultComponentProps
}
from '@interface/common'

/**
 * Components
 */
import Button from '@components/button'

/**
 * Images
 */
import Close from '@assets/images/close.png'

/**
 * Modal content
 */
const RISK_TIERS = [
  {value: 'low', label: 'Low'},
  {value: 'medium', label: 'Medium'},
  {value: 'high', label: 'High'},
  {value: 'critical', label: 'Critical'},
]

export default pure(({user, store, modal}: DefaultComponentProps) => {
  const state = store.useLocalState({
    post: {
      user: {}
    },
    loading: true,
    tier: 'low',
  })

  /**
   * Get post
   */
  React.useEffect(() => {

    http.get(`/posts/${modal.data.pid}`)

    .then(({status, result}: HttpResponse) => {
      if(status === 200) {
        const img = new Image()
        img.onerror = () => {
          state.set({noPhoto: true})
        }
        img.src = result.user.photo

        state.set({post: result, loading: false})
      }
    })
    .catch((e: any) => {
      state.set({error: e.message})
    })
  }, [])


  
  /**
   * Approve or Block post
   */
  function update(action: string, post: PostInterface) {
    /**
     * Send request
     */
    http.put(`/posts/${post.pid}`, {
      data: {
        post: {
          pid: post.pid,
          uid: post.user.uid,
        },
        action: action,
        moderator: user.uid,
        tier: state.tier,
      }
    })
    .then(({status}: HttpResponse) => {
      if(status === 200) {
        modal.close({updated: {action, post}})
      }
    })
    .catch((e: any) => {
      state.set({error: e.data.result.error})
    })
  }


  return (
    <div
      id="review"
      onClick={(e) => {
        e.stopPropagation()
      }}>
      <div className="head">
        <h2>{user.organization.role === 'Organization Administrator' ? 'Post' : 'Review Post'}</h2>
        <span
          className="close"
          onClick={() => {
            modal.close()
          }}>
          <img alt="Close" src={Close}/>
        </span>
      </div>
      {state.loading ? (
        <div
          style={{
            padding: 40,
            marginBottom: 30,
            textAlign: 'center',
            border: '1px solid #ddd',
          }}>
          {/* <img src={Spinner} width={32}/> */}
        </div>
      ):(
        <div
          style={{
            lineHeight: 0,
            borderRadius: 5,
            marginBottom: 30,
            overflow: 'hidden',
            border: '1px solid #ddd',
          }}>
          <div className="avatar">
            <span className="image">
              {!state.noPhoto && (
                <img src={state.post.user.photo} alt="User avatar"/>
              )}
            </span>
            <span className="name">
              <strong>{state.post.user.firstname} {state.post.user.lastname}</strong>
              <span>@{state.post.user.username}</span>
            </span>
          </div>
          {state.post.text && (
            <div style={{lineHeight: 1.5, padding: '0 20px 15px'}}>{state.post.text}</div>
          )}
          {state.post.media && (
            <img
              width={'100%'}
              alt="Post media"
              src={state.post.media && state.post.media.path}
            />
          )}
        </div>
      )}
      
      {user.organization.role === 'Administrator' && (
        <>
          <div style={{marginBottom: 20}}>
            <label
              htmlFor="risk-tier"
              style={{display: 'block', marginBottom: 8, fontWeight: 600, fontSize: 14}}>
              Risk Tier
            </label>
            <select
              id="risk-tier"
              value={state.tier}
              onChange={(e) => state.set({tier: e.target.value})}
              style={{
                width: '100%',
                padding: '10px 12px',
                borderRadius: 5,
                border: '1px solid #ddd',
                fontSize: 14,
                background: '#fff',
              }}>
              {RISK_TIERS.map(t => (
                <option key={t.value} value={t.value}>{t.label}</option>
              ))}
            </select>
          </div>
          <Button
            style={{
              width: '100%'
            }}
            label={'Block'}
            onClick={() => {
              update('block', state.post)
            }}
            className={'button-1'}
          />
          <Button
            style={{
              width: '100%',
              marginTop: 20
            }}
            label={'Approve'}
            onClick={() => {
              update('approve', state.post)
            }}
            className={'button-3'}
          />
        </>
      )}
    </div>
  )
})
